<template>
    <base-panel
        :panel="panel"
        v-on:continue="handleContinue()"
        v-on:edit-action="handleEditAction($event)"
        v-on:update-width="updatePanelWidth($event)"
        :no-padding="omitPanelPadding"
        ref="basePanel"
    >
        <template slot="content">
            <rich-content-display
                :elements="panel.elements"
                :videoComplete.sync="panel.videoComplete"
                v-on:continue="handleContinue()"
                v-on:video-complete="handleVideoComplete()"
                v-on:image-loaded="relayImageLoaded()"
                :skip-media-to-end="skipMediaToEnd || videoComplete"
                :close-full-screen-videos-after-end="nodeHasMultiplePanels"
                :show-continue-button-on-videos="!nodeHasMultiplePanels && node.continue_button"
                :continue-btn-text="continueButtonText"
                :show-hr-dividers="panel.display_hr_dividers"
                :editable="editable"
                :extra-element-classes="extraElementClasses"
                ref="richContentDisplay"
            ></rich-content-display>
        </template>
    </base-panel>
</template>

<script>
import RichContentDisplay from "@/components/RichContentDisplay"
import BasePanel from "@/components/panels/BasePanel"

export default {
    name: "CustomPanel",
    components: {
        RichContentDisplay,
        BasePanel,
    },
    props: {
        node: {
            type: Object,
            required: true,
        },
        panel: {
            type: Object,
            required: true,
        },
        skipMediaToEnd: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            videoComplete: this.$store.getters.preContentVideoComplete,
        }
    },
    computed: {
        nodeHasMultiplePanels() {
            return this.$store.getters.sessionCurrentPanels.length > 1
        },
        labelsTranslated() {
            return this.$store.getters.sessionLabelsTranslated
        },
        continueButtonText() {
            if (!this.node.continue_button_text || this.node.continue_button_text === "") {
                return this.labelsTranslated.continue
            }
            return this.node.continue_button_text
        },
        noSubheader() {
            return this.panel.sub_header === "" || this.panel.sub_header === "<p></p>"
        },
        // True if the panel only contains one 'media' type element.
        isSingleMediaPanel() {
            return (
                this.panel.elements.length === 1 &&
                ["image", "image_ai", "video", "vimeo", "youtube"].includes(this.panel.elements[0].element_type) &&
                !this.panel.elements[0].display_full_screen &&
                this.noSubheader
            )
        },
        // An array of extra classes to be applied to elements within the panel.
        extraElementClasses() {
            if (this.isSingleMediaPanel && this.panel.header && this.omitPanelPadding) {
                return ["top-no-round"]
            }
            return []
        },
        // Controls whether or not the panel should include the default padding (i.e. style). When a panel
        // contains a single media element and the element hasn't been resized, padding is removed to create
        // a cleaner display.
        omitPanelPadding() {
            return (
                this.isSingleMediaPanel &&
                this.panel.elements[0].display_width === 100 &&
                this.panel.elements[0].display_width_units === "%"
            )
        },
    },
    methods: {
        handleVideoComplete() {
            this.$store.commit("setPreContentVideoComplete", true)
        },
        relayImageLoaded() {
            this.$emit("image-loaded")
        },
        reset() {
            if (this.$refs.richContentDisplay) {
                this.$refs.richContentDisplay.resetEmbedElements()
            }
        },
        handleContinue() {
            this.$emit("continue")
        },
        handleEditAction(action) {
            this.$emit("edit-action", action)
        },
        updatePanelWidth($event) {
            return this.$emit("update-width", $event)
        },
        skipVideos() {
            this.$refs.basePanel.skipVideos()
            if (this.$refs.richContentDisplay) {
                this.$refs.richContentDisplay.skipVideos()
            }
        },
    },
    mounted() {
        let requiredVideoElements = this.panel.elements.find((e) => e.play_video_before_continue)
        if (requiredVideoElements) {
            this.$emit("update:videoComplete", false)
        } else {
            this.$emit("update:videoComplete", true)
        }
    },
}
</script>
